import { message } from 'antd';
import { call, put, all, takeLatest } from 'redux-saga/effects'
import { fetchAllTechniciansAPI, fetchWorklistAPI, undoVisitAPI, updateExaminationStateAPI } from '../../../services/worklist-service'
import { FETCH_ALL_TECHNICIANS, FETCH_ALL_TECHNICIANS_ERROR, FETCH_ALL_TECHNICIANS_START, FETCH_ALL_TECHNICIANS_SUCCESS } from '../../actions/receptionist/techniciansAction';
import { FETCH_WORKLIST, FETCH_WORKLIST_ERROR, FETCH_WORKLIST_SUCCESS, UPDATE_WORKLIST_EXAMINATION_STATE, UPDATE_WORKLIST_EXAMINATION_STATE_SUCCESS, UPDATE_WORKLIST_EXAMINATION_STATE_ERROR, UNDO_WORKLIST_VISIT, UNDO_WORKLIST_VISIT_START, UNDO_WORKLIST_VISIT_SUCCESS, UNDO_WORKLIST_VISIT_ERROR, FETCH_WORKLIST_START, SET_WORKLIST_PAGINATION } from '../../actions/receptionist/worklistAction'

function* fetchWorklist({ payload }) {
    try {
        yield put({ type: FETCH_WORKLIST_START })
        const response = yield call(fetchWorklistAPI, payload);
        //console.log("response---", response);
        if (response.success) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalCount,
            }
            yield put({ type: FETCH_WORKLIST_SUCCESS, worklist: response.data.data.length > 0 ? [...response.data.data] : [] })
            yield put({ type: SET_WORKLIST_PAGINATION, pagination: pagination });
        } else {
            message.error(response?.error?.response?.data || 'Failed to fetch worklist!');
            yield put({ type: FETCH_WORKLIST_ERROR, error: response.error })
        }
    } catch (error) {
        message.error('Failed to fetch worklist!');
        yield put({ type: FETCH_WORKLIST_ERROR, error: error })
    }
}

function* updateExaminationState({ payload }) {

    try {
        const response = yield call(updateExaminationStateAPI, payload.worklist);

        if (response.success) {
            if (response.data.endTime === null) {
                message.success('Visit started successfully.');
            } else {
                message.success('Visit completed successfully.');
            }

            yield put({ type: UPDATE_WORKLIST_EXAMINATION_STATE_SUCCESS, worklistItem: { ...response.data } })
        } else {
            message.error('Failed to update worklist!');
            yield put({ type: UPDATE_WORKLIST_EXAMINATION_STATE_ERROR, error: response.error })
        }
    } catch (error) {
        message.error('Failed to update worklist!');
        yield put({ type: UPDATE_WORKLIST_EXAMINATION_STATE_ERROR, error: error })
    }
}


function* fetchTechnicians() {
    try {
        yield put({ type: FETCH_ALL_TECHNICIANS_START })
        const response = yield call(fetchAllTechniciansAPI);
        if (response.success) {
            yield put({ type: FETCH_ALL_TECHNICIANS_SUCCESS, technicians: response.data.length > 0 ? [...response.data] : [] })
        } else {
            message.error('Failed to fetch Technicians!');
            yield put({ type: FETCH_ALL_TECHNICIANS_ERROR, error: response.error })
        }
    } catch (error) {
        message.error('Failed to fetch Technicians!');
        yield put({ type: FETCH_ALL_TECHNICIANS_ERROR, error: error })
    }
}

function* undoWorklistVisit({ payload }) {
    try {
        yield put({ type: UNDO_WORKLIST_VISIT_START })
        const response = yield call(undoVisitAPI, payload);
        if (response.success) {
            message.success('Undo visit successfully.');
            yield put({ type: UNDO_WORKLIST_VISIT_SUCCESS, visitNo: payload })
        } else {
            message.error('Failed to undo visit!');
            yield put({ type: UNDO_WORKLIST_VISIT_ERROR, error: response.error })
        }
    } catch (error) {
        message.error('Failed to undo visit!');
    }
}


function* worklistWatcher() {
    yield takeLatest(FETCH_WORKLIST, fetchWorklist)
    yield takeLatest(UPDATE_WORKLIST_EXAMINATION_STATE, updateExaminationState)
    yield takeLatest(FETCH_ALL_TECHNICIANS, fetchTechnicians)
    yield takeLatest(UNDO_WORKLIST_VISIT, undoWorklistVisit)
}

export default function* rootSaga() {
    yield all([worklistWatcher()])

}